// src/pages/Historico.js - VERSÃO FINAL COM FUNÇÃO DE CANCELAR
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, getDocs, orderBy, doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';

function Historico() {
    const navigate = useNavigate();
    const [historico, setHistorico] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isCanceling, setIsCanceling] = useState(null); // Controla o estado de loading do cancelamento
    const [expandedId, setExpandedId] = useState(null);

    // Função para buscar os dados do histórico (sem alterações)
    const fetchHistorico = async () => {
        setIsLoading(true);
        try {
            const q = query(collection(db, "historico_cotacoes"), orderBy("dataEfetivacao", "desc"));
            const querySnapshot = await getDocs(q);
            const lista = querySnapshot.docs.map(doc => doc.data());
            setHistorico(lista);
        } catch (error) {
            console.error("Erro ao buscar histórico: ", error);
            alert("Não foi possível carregar o histórico.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchHistorico();
    }, []);
    
    // ***** NOVA FUNÇÃO PARA CANCELAR UMA COTAÇÃO *****
    const handleCancelarCotacao = async (cotacaoParaCancelar) => {
        if (isCanceling) return; // Previne múltiplos cliques
        
        const confirm = window.confirm(`Tem certeza que deseja cancelar a cotação ${cotacaoParaCancelar.id}?\nEsta ação irá DEVOLVER os saldos para as secretarias e não pode ser desfeita.`);
        if (!confirm) {
            return;
        }

        setIsCanceling(cotacaoParaCancelar.id);

        try {
            // 1. Pegar o saldo atual
            const saldosDocRef = doc(db, "saldos", "por_secretaria");
            const saldosDoc = await getDoc(saldosDocRef);

            if (!saldosDoc.exists()) {
                throw new Error("Documento de saldos não encontrado!");
            }

            const saldosAtuais = saldosDoc.data();
            // Criamos uma cópia para não alterar o estado original antes da hora
            const novosSaldos = JSON.parse(JSON.stringify(saldosAtuais));

            // 2. Devolver os valores da cotação cancelada para os saldos
            const detalhesDaCotacao = cotacaoParaCancelar.detalhes;
            for (const secretaria in detalhesDaCotacao) {
                for (const item of detalhesDaCotacao[secretaria]) {
                    if (item.usado > 0) {
                        // Adiciona de volta a quantidade usada
                        novosSaldos[secretaria][item.nome] += item.usado;
                    }
                }
            }

            // 3. Salvar o novo saldo no banco de dados
            await setDoc(saldosDocRef, novosSaldos);

            // 4. Marcar a cotação como "Cancelada" no histórico
            const historicoDocRef = doc(db, "historico_cotacoes", cotacaoParaCancelar.id);
            await updateDoc(historicoDocRef, {
                status: "Cancelada"
            });

            // 5. Atualizar a lista na tela para refletir a mudança imediatamente
            setHistorico(historico.map(h => 
                h.id === cotacaoParaCancelar.id ? { ...h, status: 'Cancelada' } : h
            ));

            alert(`Cotação ${cotacaoParaCancelar.id} cancelada com sucesso! Os saldos foram restaurados.`);

        } catch (error) {
            console.error("Erro ao cancelar cotação:", error);
            alert("Ocorreu um erro ao tentar cancelar a cotação. Verifique o console para mais detalhes.");
        } finally {
            setIsCanceling(null); // Libera o botão
        }
    };


    const toggleDetails = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    if (isLoading) {
        return <div className="app-container"><div>Carregando histórico...</div></div>;
    }

    return (
        <div className="app-container">
            <header>
                Histórico de Cotações Efetivadas
                <button className="btn-historico" onClick={() => navigate('/')}>Voltar para Cotações</button>
            </header>
            <div className="container historico-container">
                {historico.length === 0 ? (
                    <p>Nenhuma cotação foi efetivada ainda.</p>
                ) : (
                    historico.map((cotacao) => (
                        <div key={cotacao.id} className={`card historico-card ${cotacao.status === 'Cancelada' ? 'cancelada' : ''}`}>
                            <div className="historico-card-header">
                                <div>
                                    <strong>ID:</strong> {cotacao.id} <br />
                                    <strong>Status:</strong> <span className={`status-${cotacao.status.toLowerCase()}`}>{cotacao.status}</span>
                                </div>
                                <div>
                                    <strong>Data Efetivada:</strong> {new Date(cotacao.dataEfetivacao).toLocaleDateString('pt-BR')} <br />
                                    <strong>Valor Total:</strong> R$ {cotacao.valorTotal.toFixed(2)}
                                </div>
                            </div>
                            <div className="historico-card-actions">
                                <button className="btn" onClick={() => toggleDetails(cotacao.id)}>
                                    {expandedId === cotacao.id ? 'Ocultar Detalhes' : 'Ver Detalhes'}
                                </button>
                                {cotacao.status !== 'Cancelada' && (
                                     <button 
                                        className="btn-cancelar" 
                                        onClick={() => handleCancelarCotacao(cotacao)}
                                        disabled={isCanceling === cotacao.id}
                                     >
                                        {isCanceling === cotacao.id ? 'Cancelando...' : 'Cancelar Cotação'}
                                     </button>
                                )}
                            </div>
                            {expandedId === cotacao.id && (
                                <div className="historico-card-details">
                                    <hr />
                                    <p><strong>Data do Orçamento:</strong> {new Date(cotacao.dataOrcamento + 'T00:00:00').toLocaleDateString('pt-BR')}</p>
                                    {Object.keys(cotacao.detalhes).map(secretaria => {
                                        const itensUsados = cotacao.detalhes[secretaria].filter(item => item.usado > 0);
                                        if (itensUsados.length === 0) return null;
                                        return (
                                            <div key={secretaria} className="detalhe-secretaria">
                                                <h4>{secretaria}</h4>
                                                <ul>
                                                    {itensUsados.map(item => (
                                                        <li key={item.nome}>
                                                            {item.nome}: {item.usado} un. x R$ {item.valor.toFixed(2)} = <strong>R$ {(item.usado * item.valor).toFixed(2)}</strong>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default Historico;
